import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { url } from "../config";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    // State to hold the authentication token
    const [token, setToken_] = useState();
    const [logged, setLogged] = useState(false);

    // Function to set the authentication token
    const setToken = (newToken) => {
        setToken_(newToken);
        if (newToken == null) {
            localStorage.removeItem("ll_token");
        } else {
            localStorage.setItem("ll_token", newToken);
        }
    };

    async function login(email, password) {
        console.log("LOGIN");
        console.log(email);
        console.log(password);
        setLoading(true);

        try {
            var { data } = await axios.post(`${url}/auth/login`, {
                "username": email,
                password,
            });
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            // console.log(data);
            setLogged(true);
            setToken(data.token);
            setLoading(false);
            // console.log(data.token);
            setUser(data.user);
            localStorage.setItem("user", JSON.stringify(data.user));
            console.log(user);
            // console.log(data.user);
        } catch (error) {
            return "err";
        }
    }


    // Call the logout endpoint and then remove the user
    // from the state.
    function logout() {
        setLogged(false);
        setLoading(false);
        setToken(null);
        // sessionsApi.logout().then(() => setUser(undefined));
    }

    useEffect(() => {

        let tkn = localStorage.getItem("ll_token");
        console.log(tkn);
        console.log(typeof tkn);

        if (tkn !== null && tkn !== "null") {
            setLogged(true);
            setLoading(false);
            setToken(tkn);

            // set user too
            setUser(JSON.parse(localStorage.getItem("user")));
        } else {
            setLogged(false);
            setLoading(false);
            setToken(null);
        } 

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Memoized value of the authentication context
    const contextValue = useMemo(
        () => ({
            loading,
            logged,
            token,
            user,
            login,
            setToken,
            logout,
        }),
        [token, logged] // eslint-disable-line react-hooks/exhaustive-deps
    );

    // Provide the authentication context to the children components
    return (
        <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export default AuthProvider;